
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 40 40"}},[_c('path',{attrs:{"d":"M28.334 13.883a3.867 3.867 0 00-1.767-3.25 6.668 6.668 0 00-4.933-5.417c0-.067.033-.133.033-.217a1.667 1.667 0 10-3.333 0 1.168 1.168 0 00.05.233 6.621 6.621 0 00-4.95 5.4 3.889 3.889 0 00-1.767 3.251v1.667a2.675 2.675 0 00.35 1.317 3.392 3.392 0 00-.35 1.466v15A3.343 3.343 0 0015 36.666h10a3.343 3.343 0 003.334-3.333v-15a3.265 3.265 0 00-.35-1.45 2.788 2.788 0 00.35-1.333zM20 8.333A3.335 3.335 0 0122.867 10h-5.733A3.335 3.335 0 0120 8.333zm-5 5.55a.555.555 0 01.55-.55h8.883a.559.559 0 01.567.55V15H15zm0 19.45v-15h10v15z"}}),_c('path',{attrs:{"d":"M17.717 21.666h4.55v1.667h-4.55zm0 3.334h4.55v1.667h-4.55zm0 3.333h4.55V30h-4.55z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      